// extracted by mini-css-extract-plugin
export default {"mCard":"xB-z","image":"yB-z","imageNoBackground":"zB-z","imageHasCategory":"AB-z","fullWidth":"BB-z"};